(function () {
  var path = window.location.pathname.replace(/\/+$/, '') || '/';
  var country =
    window.ShopifyVars &&
      window.ShopifyVars.context &&
      window.ShopifyVars.context.country
      ? window.ShopifyVars.context.country
      : 'unknown';
  var cacheKey = country + '::' + path;
  var hasView = new URLSearchParams(window.location.search).has('view');
  var hasAbControl = new URLSearchParams(window.location.search).has('ab_control');
  var canHaveContentExperiment =
    path === '/' ||
    path.indexOf('/products') === 0 ||
    path.indexOf('/collections') === 0 ||
    path.indexOf('/pages') === 0;

  // Có ab_control = đây là trang variant (B) vừa landing qua redirect từ Split URL.
  // Assignment đã xảy ra ở trang control (A) rồi — B không tự lookup experiment
  // nữa (theo thiết kế BE chỉ match path A), nên không cần ẩn trang/chờ gì cả.
  if (hasView || hasAbControl || !canHaveContentExperiment) {
    var unusedStyle = document.getElementById('ab-prehide-style');
    if (unusedStyle) unusedStyle.remove();
    return;
  }

  document.documentElement.classList.add('ab-prehide');

  try {
    var cache = JSON.parse(sessionStorage.getItem('ab_content_experiment_cache') || '{}');
    var cachedData = cache[cacheKey];

    // Cache lưu sẵn "action" (stay/redirect) đã tính từ main script — prehide chỉ
    // cần đọc và áp dụng, không cần biết đây là loại experiment gì (template,
    // split url, hay loại mới thêm sau này). Không cần sửa file này khi mở rộng thêm loại.
    if (cachedData && cachedData.action === 'redirect') {
      window.location.replace(cachedData.url);
      return;
    }

    if (cachedData && cachedData.action === 'stay') {
      var controlStyle = document.getElementById('ab-prehide-style');
      if (controlStyle) controlStyle.remove();
      return;
    }
  } catch (e) {
    console.warn('[ABStudio] Failed to read prehide cache:', e);
  }

  if (document.getElementById('ab-loader')) return;

  var loader = document.createElement('div');
  loader.id = 'ab-loader';
  loader.setAttribute('role', 'status');
  loader.setAttribute('aria-live', 'polite');
  loader.textContent = 'Loading';
  document.documentElement.appendChild(loader);

  window.__abPrehideTimer = setTimeout(function () {
    if (window.__abMainStarted) return;

    document.documentElement.classList.remove('ab-prehide');
    var staleLoader = document.getElementById('ab-loader');
    var staleStyle = document.getElementById('ab-prehide-style');
    if (staleLoader) staleLoader.remove();
    if (staleStyle) staleStyle.remove();
  }, 3000);
})();